import React from 'react';
import { observer } from 'mobx-react';
import { MeasureResultsModel } from './MeasureResultsModel';
import { MapViewInputManager } from 'cd-eft/business/MapViewInputManager/MapViewInputManager';
import { OnChangeMeasureToolHandler } from 'cd-eft/business/MapViewInputManager/MeasureInputResult';
import { ISelectedMeasurementUnits } from './MeasureToolboxView';

interface IMeasureAreaToolViewProps {
  inputManager: MapViewInputManager;
  measureResults: MeasureResultsModel;
  onChangeMeasureTool: OnChangeMeasureToolHandler;
  measurementUnits: ISelectedMeasurementUnits;
}

export const MeasureAreaToolView = observer(function (props: IMeasureAreaToolViewProps) {
  let isSelectedClass = '';
  if (props.inputManager.currentOperationType == 'measure-area') {
    isSelectedClass = 'widget-button--active';
  }
  return (
    <button
      className={`esri-widget--button esri-interactive esri-icon-measure-area widget-button ${isSelectedClass}`}
      title="Area Measurement"
      onClick={async (event) => {
        props.onChangeMeasureTool('measure-area');
        try {
          props.measureResults.activeFeedback = undefined;
          const measureResult = await props.inputManager.measureAreaAsync(props.measurementUnits, (feedback) => {
            props.measureResults.activeFeedback = feedback;
          });

          props.measureResults.addResult(measureResult);
        } catch (error) {
          if ((error as Error).message !== 'Action interrupted by user.') {
            // rethrow unexpected exception,
            throw error;
          }
        }
      }}
    ></button>
  );
});
